<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 :config="config"
                                 ref="processExecution"
                                 @gotItems="setLocalVariables"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>
            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete :task-id="$_emWorkflowTaskMixin_taskId"
                                      syncValueChange
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      :config="config">
                </WorkflowTaskComplete>
            </div>
        </section>
    </div>
</template>
<script>
    // Author Lin
    // Date 2021-08-13 17:47:46

    import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
    import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";
    import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
    import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";

    export default {
        name: "sithMesInventoryChangeMaterialProjectWorkflowTaskView",
        components: {WorkflowProcessLine, WorkflowTaskComplete},
        mixins: [emWorkflowTaskMixin, workflowTaskMixins],
        computed: {
            modelName() {
                return this.$_emRouterHelperMixin_entityName
            },
            $_emWorkflowTaskMixin_callbackApi() {
                return process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryChangeMaterialProject/complete-feedback";
            },
            config() {
                return {
                    'task1': {
                        tag: {},
                        name: '发起转库申请',
                        variables: [
                            {
                                label: '流程管理',
                                type: this.VALUE_TYPE.SELECT,
                                saveTo: this.SAVE_TO.APPROVE,
                                options: [
                                    {value: 1, text: '确认发起'},
                                    {value: 3, text: '撤销流程'}
                                ],
                                changeTag: val => {
                                    return this.buildTag('notClose', val === 1);
                                }
                            },
                            {
                                needTag: 'notClose',
                                label: '是否需要财务审批',
                                name: 'financialRequired',
                                type: this.VALUE_TYPE.SELECT,
                                saveTo: this.SAVE_TO.DATABASE,
                                options: [
                                    {value: true, text: '是'},
                                    {value: false, text: '否'},
                                ],
                                initData: true,
                            },
                        ],
                        setApproveByVariable: [
                            {
                                variableName: 'financialRequired',
                                handler: (approve, val) => {
                                    if (approve === 1 && val) {
                                        return 1;
                                    } else if(approve ===1 && !val) {
                                        return 2;
                                    }
                                    return approve;
                                }
                            },
                        ],
                        userSelectMap: {
                            1: [
                                {
                                    name: 'task_financial_candidates',
                                    allowMulti: true,
                                    require: true
                                }
                            ],
                            2: [
                                {
                                    name: 'task_log_candidates',
                                    allowMulti: true,
                                    require: true
                                }
                            ]
                        },
                        approveToNextTask: {
                            1: 'task2',
                            2: 'task3',
                            3: 'complete_reject'
                        },
                        defaultAssignee: true
                    },
                    'task2': {
                        name: '财务审核',
                        approveLabel: '是否通过',
                        userSelectMap: {
                            '1' : [
                                {
                                    name: 'task_log_candidates',
                                    allowMulti: true,
                                    require: true
                                }
                            ]
                        },
                        postByApprove: () => {
                            return {
                                url: process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryChangeMaterialProject/task2/setApprover",
                                data: {
                                    id: this.$_emWorkflowTaskMixin_businessKey,
                                }
                            };
                        },
                        approveToNextTask: {
                            1: 'task3',
                            2: 'task1'
                        }
                    },
                    'task3': {
                        name: '物流确认',
                        approveLabel: '是否同意',
                        variables: [
                            {
                                label: '备注',
                                name: 'remark',
                                type: this.VALUE_TYPE.TEXTAREA,
                                saveTo: this.SAVE_TO.DATABASE,
                                initData: true,
                            },
                        ],
                        setApproveByBusinessData: (businessData, approve) => {
                            // 驳回且流程需要财务审批，则返回给财务
                            if (businessData.financialRequired && approve === 2) {
                                return 2;
                            }
                            // 驳回且流程不需要财务审批，则返回给OM
                            if (!businessData.financialRequired && approve === 2) {
                                return 3;
                            }
                            
                            return approve;
                        },
                        postByApprove: (approve) => {
                            return {
                                url: process.env.VUE_APP_SITHMES_INVENTORY_URL + `/sithMesInventoryChangeMaterialProject/task3/setApprover?approvedStatus=${approve}`,
                                data: {
                                    id: this.$_emWorkflowTaskMixin_businessKey,
                                }
                            };
                        },
                        approveToNextTask: {
                            1: 'complete_transfer',
                            2: 'task2',
                            3: 'task1'
                        }
                    },
                    'complete_transfer': {
                        name: '转库完成'
                    },
                    'complete_reject': {
                        name: '撤销申请'
                    }
                }
            }
        }
    };
</script>